import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const options={
    position: toast.POSITION.TOP_RIGHT,
}
export const Alert ={
    success(messages){toast.success(messages, options)},
    info(messages){toast.info(messages, options)},
    warn(messages){toast.warn(messages, options)},
    error(messages){toast.error(messages, options)},
}